import dynamic from 'next/dynamic';
import { config } from '@abyss/web/tools/config';
import { storage } from '@abyss/web/tools/storage';
import { parseSessionCookie } from 'commonUtils/src/sessionManager';

export const LDProvider = dynamic(
  async () => {
    const { asyncWithLDProvider } =
      await import('launchdarkly-react-client-sdk');
    const containerUser = parseSessionCookie(
      storage.cookie.get('FINDCARE_AND_COST_SSO_SESSION')
    ).memberId;
    return asyncWithLDProvider({
      clientSideID: config('LD_CLIENT_ID_PSX') || '65a48dce975b3a1017c7be9d',
      context: {
        key: containerUser || 'container-test-user',
        kind: 'user',
        name: containerUser || 'container-test-user',
      },
    });
  },
  { ssr: false }
);
